<template>
  <div>
    <o-table ref="tableList" :enable-edit="false" :enable-new="false"
             :title="$t('sandoz.kickout_report_ignores')" url="/api/sandoz/wholesaler_kickout_ignores">
      <template slot="filter">
        <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
          <o-filter-monthpicker :title="$t('sandoz.year_month')" column="year_month"></o-filter-monthpicker>
          <o-filter-select :title="$t('sandoz.year')" column="year" :items="years"></o-filter-select>
          <o-filter-text :prepend-percentage="true" :title="$t('sandoz.whs_customer_name')"
                         column="whs_customer_name"></o-filter-text>
          <o-filter-text :title="$t('sandoz.whs_customer_code')" column="whs_customer_code"></o-filter-text>
          <o-filter-text :title="$t('sandoz.wholesaler_code')" column="wholesaler_code"></o-filter-text>
          <o-filter-text :title="$t('sandoz.reportname')" column="reportname"></o-filter-text>
          <o-filter-text :title="$t('sandoz.reportcode')" column="reportcode"></o-filter-text>
          <o-filter-text :title="$t('sandoz.whs_customer_zip')" column="localkey_zip"></o-filter-text>
          <o-filter-text :title="$t('sandoz.reason')" column="reason"></o-filter-text>
          <o-filter-text :title="$t('sandoz.whs_customer_localkey')" column="whs_customer_localkey"></o-filter-text>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="year_month">{{ $t('sandoz.year_month') }}</o-table-header>
        <o-table-header column="whs_ean">{{ $t('sandoz.whs_ean') }}</o-table-header>
        <o-table-header column="whs_customer_name">{{ $t('sandoz.whs_customer_name') }}</o-table-header>
        <o-table-header column="whs_customer_code">{{ $t('sandoz.whs_customer_code') }}</o-table-header>
        <o-table-header column="whs_customer_localkey">{{ $t('sandoz.whs_customer_localkey') }}</o-table-header>
        <o-table-header column="wholesaler_code">{{ $t('sandoz.wholesaler_code') }}</o-table-header>
        <o-table-header column="value">{{ $t('sandoz.value') }}</o-table-header>
        <o-table-header column="reason">{{ $t('sandoz.reason') }}</o-table-header>
        <o-table-header column="reportname">{{ $t('sandoz.reportname') }}</o-table-header>
        <o-table-header column="reportcode">{{ $t('sandoz.reportcode') }}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
        <td>{{ props.item.year_month }}</td>
        <td>{{ props.item.whs_ean }}</td>
        <td>{{ props.item.whs_customer_name }}</td>
        <td>{{ props.item.whs_customer_code }}</td>
        <td>
          <o-text-preview>{{ props.item.whs_customer_localkey }}</o-text-preview>
        </td>
        <td>
          <o-text-preview>{{ props.item.wholesaler_code }}</o-text-preview>
        </td>
        <td>{{ props.item.value }}</td>
        <td>{{ props.item.reason }}</td>
        <td>{{ props.item.reportname }}</td>
        <td>{{ props.item.reportcode }}</td>
      </template>
    </o-table>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button variant="outline-primary" @click.prevent="back">{{ $t('core.back') }}</o-button>
      </div>
    </o-action-toolbar>
  </div>
</template>

<script>

export default {
  computed: {
    years () {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let i = currentYear + 1; i >= 2018; i--) {
        years.push({ value: i, text: i })
      }
      return years
    }
  },
  methods: {
    back () {
      this.$router.back()
    }
  }
}
</script>
